import { Injectable } from "@angular/core";
import { PackageFilterData } from "../../components/list/enrichment-list-filter/enrichment-list-filter.model";
import {
  SearchScope,
  SortState,
} from "../../components/list/enrichment-list/enrichment-list.types";
import { PriceStatusTab } from "../../components/list/enrichment-list/price-status-tabs";

export interface EnrichmentListJourney {
  context: string;
  entryQuery: string | null;
  searchTerm: string;
  filters: PackageFilterData | null;
  sort: SortState;
  page: number;
  pageSize: number;
  pickedScope: SearchScope;
  codeDraft: string;
  selectedChannel: string;
  priceStatusTab: PriceStatusTab;
  scrollTop: number;
  scrollLeft: number;
}

/** One return trip from list to edit. Keep query state, never cached API rows
 * or bulk selections. A refresh starts a new journey. */
@Injectable({ providedIn: "root" })
export class EnrichmentListJourneyStore {
  private snapshot: EnrichmentListJourney | null = null;

  save(snapshot: EnrichmentListJourney): void {
    this.snapshot = snapshot;
  }

  get hasReturnState(): boolean {
    return this.snapshot !== null;
  }

  take(context: string): EnrichmentListJourney | null {
    const snapshot = this.snapshot;
    this.snapshot = null;
    return snapshot?.context === context ? snapshot : null;
  }
}
